// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3d7SI","footer":"ModalError_footer__2cIuJ"};